import { Routes, Route } from "react-router-dom";
import WebWrapperLayout from "../components/WebWrapperLayout";
import {
  Home,
  Shop,
  CategoriesPage,
  ProductDetails,
  PostReviewPage,
  Profile,
  About,
  Contact,
  Orders,
  WishList,
  MyAddress,
  Wallet,
  AddMyAddress,
  EditMyAddress,
  Cart,
  CheckoutSuccess,
  CheckoutAddress,
  CheckoutPayment,
  InvoiceOrder,
} from "../pages/web-app/index";
import { CheckoutLayout, UserProfileLayout } from "../components/index";
import UserProfileOverview from "../pages/web-app/UserProfileOverview/UserProfileOverview";
import ProtectedRoute from "./ProtectedRoute";
import Privacypolicy from "../components/Footercomponents/privacypolicy";
import Refundpolicy from "../components/Footercomponents/Refundpolicy";
import Shippingpolicy from "../components/Footercomponents/Shippingpolicy";
import Terms from "../components/Footercomponents/terms";
import PayURedirect from "../utils/PayuRedirect";
// import PayUSuccess from "../pages/web-app/Checkout/CheckoutPayment/PayuSuccess";
// import PayUSuccess from "../pages/web-app/Checkout/CheckoutPayment/PayuSuccess";
// import PayUFailure from "../pages/web-app/Checkout/CheckoutPayment/PayuFailure";
import ChangePassword from "../auth/Change-Password/ChangePassword";
import PrescriptionPage from "../src/pages/web-app/Checkout/checkoutPrescription/prescription";
import OrderSuccess from "../pages/web-app/Checkout/CheckoutPayment/RazorpaySuccess";
import ImageSearchResults from "../components/ImagesearchResults/ImageSearchResult";
import ShoppingList from "../components/ShoppingSuggestionList/SuggestionList";
// import PaypalSuccess from "../pages/web-app/Checkout/CheckoutPayment/PaypalSuccess";
// import PaypalFailure from "../pages/web-app/Checkout/CheckoutPayment/PaypalFailure";
const WebAppRoutes = () => {
  return (
    <Routes> 
      <Route element={<WebWrapperLayout />}>
        <Route index element={<Home />} />
        <Route path="shop" element={<Shop />} />
        <Route path="shop/:categorySlug" element={<Shop />} />
        <Route path="categories" element={<CategoriesPage />} /> 
       <Route
  path="image-search-results"
  element={<ImageSearchResults />}
/> <Route
  path="/shopping-list"
  element={<ShoppingList />}
/>
        <Route
          path="productdetails/:productSlug"
          element={<ProductDetails />}
        />
        {/* Reviews */}
        <Route element={<ProtectedRoute />}>
          <Route path="review/add" element={<PostReviewPage />} />
          <Route path="review/edit/:id" element={<PostReviewPage />} />
        </Route>
        {/* Invoice */}
        <Route element={<ProtectedRoute />}>
          <Route path="invoice/:invoiceNumber" element={<InvoiceOrder />} />
        </Route>
        <Route path="about" element={<About />} />
        <Route path="contact" element={<Contact />} />  
         <Route path="privacy-policy" element={<Privacypolicy/>} /> 
        <Route path="refund-policy"  element={<Refundpolicy/> }/>
        <Route path="shipping-policy"  element={<Shippingpolicy/>} />
        <Route path="terms-and-conditions" element={<Terms/> } /> 
        {/* Checkout */}
        <Route element={<CheckoutLayout />}>
          <Route path="cart" element={<Cart />} /> 
          <Route path="checkout" element={<ProtectedRoute />}>
            <Route index element={<CheckoutAddress />} />
            <Route path="address" element={<CheckoutAddress />} />
            <Route path="payment" element={<CheckoutPayment />} />
            <Route path="success" element={<CheckoutSuccess />} />  
         <Route path="prescription" element={<PrescriptionPage />} />  
          {/* <Route path="payu-redirect" element={<PayURedirect />} />    */}
           {/* <Route path="payu-success" element={<PayUSuccess />} /> */}
            {/* <Route path="payu-fail" element={<PayUFailure />} /> */}
          {/* <Route path="paypal-success" element={<PaypalSuccess />} /> */}
{/* <Route path="paypal-fail" element={<PaypalFailure/>} />  */}
<Route path="order-success" element={<OrderSuccess />} /> 
          </Route>   
        </Route>
        {/* Profile */}
        <Route
          path="profile"
          element={
            <ProtectedRoute>
              <UserProfileLayout />
            </ProtectedRoute>
          }
        >
          <Route element={<UserProfileOverview />}>
            <Route index element={<Profile />} />
            <Route path="order" element={<Orders />} />
            <Route path="wishlist" element={<WishList />} />
            <Route path="address" element={<MyAddress />} />
            <Route path="address/add-address" element={<AddMyAddress />} />
            <Route path="address/edit/:id" element={<EditMyAddress />} />
            <Route path="wallet" element={<Wallet />} /> 
            <Route path="change-password" element={<ChangePassword/>}  /> 
          
          </Route>
        </Route>
      </Route>
    </Routes>
  );
};
export default WebAppRoutes;